export default function () {
    this.opts.onClick = {
        close: true,
        preventDefault: false,
        setSelected: true
    };
}
;



//////////////////
// WEBPACK FOOTER
// /Users/emmanuelpiguet/Documents/Web/Local/icmc/app/public/wp-content/themes/icmc/node_modules/mmenu-js/dist/wrappers/angular/mmenu.angular.js
// module id = 89
// module chunks = 0